<template>
  <div :class="{ 'is-invalid': $v.checkboxValue.$error }">
    <label v-html="addNbsp(getLocaleText(inputData.label))" />
    <div
      v-for="(choice, index) in values"
      :key="`${choice.id}_${index}`"
      class="text-left custom-control custom-checkbox"
    >
      <v-checkbox
        v-model="$v.checkboxValue.$model"
        data-cy="UlChoiceCheckbox"
        :error="$v.checkboxValue.$error"
        :value="choice"
        hide-details="auto"
        :class="{ 'mb-2 mb-md-4': index < values.length - 1 }"
      >
        <template #label>
          <span v-html="addNbsp(getLocaleText(choice.value))" />
          <template v-if="choice.helpPictureUrl">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon :id="`ulCheckbox-help-icon-${choice.id}`" class="ml-2" v-on="on">
                  $question
                </v-icon>
              </template>
              <v-img :src="choice.helpPictureUrl" alt="" />
            </v-tooltip>
          </template>
        </template>
      </v-checkbox>
      <div v-for="(input, index) in dependentInputs(inputData, choice.id, formName)" :key="index">
        <DynamicFormInput
          v-if="showInput(input, formName)"
          :key="input.id + index"
          class="dynamic-form-input mt-2"
          :input-data="input"
          :form-name="formName"
          store="abc"
        />
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';
import formGtm from '@/mixins/formGtm';
import dynamicForms from '@/mixins/dynamicForms';
import sortableValues from '@/mixins/sortableValues';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'UlChoice',
  mixins: [formGtm, dynamicForms, sortableValues],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      checkboxValue: []
    };
  },
  validations() {
    if (this.inputData.required) {
      return {
        checkboxValue: { required }
      };
    }
    return { checkboxValue: {} };
  },
  computed: {
    responses() {
      return this.$store.getters['dynamicForms/responses'];
    },
    values() {
      let values = lodash.cloneDeep(this.inputData.values);
      if (!this.inputData.sortValues) {
        return values;
      }

      return this.sortValues(values);
    }
  },
  watch: {
    checkboxValue(newArray, oldArray) {
      if (newArray.length) {
        let newValue = newArray.filter(val => !oldArray.map(value => value.id).includes(val.id));

        if (newValue.length) {
          if (newValue[0].onlyThisValue) {
            this.checkboxValue = [newValue[0]];
          } else {
            this.checkboxValue = newArray.filter(val => !val.onlyThisValue);
          }
        }
      }
      this.validate();

      this.$store.dispatch('dynamicForms/updateResponse', {
        id: this.inputData.id,
        value: this.checkboxValue.length ? this.checkboxValue.map(val => val.id) : null,
        formName: this.formName
      });

      const areSame =
        newArray?.length === oldArray?.length &&
        oldArray.every((elem, index) => elem === newArray[index]);

      if (!areSame) {
        this.$emit('update:value');
      }
    }
  },
  created() {
    if (
      this.responses[this.formName][this.inputData.id] &&
      this.responses[this.formName][this.inputData.id].length
    ) {
      let newValue = [];
      if (Array.isArray(this.responses[this.formName][this.inputData.id])) {
        for (let response of this.responses[this.formName][this.inputData.id]) {
          newValue.push(this.getInputValue(response));
        }
      } else {
        newValue.push(this.getInputValue(this.responses[this.formName][this.inputData.id]));
      }

      this.checkboxValue = newValue;
      this.validate();
    }

    this.$v.$reset();
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => this.validate());
  },
  destroyed() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    validate() {
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
    },
    getInputValue(response) {
      return this.inputData.values.find(val => `${val.id}` === `${response}`);
    }
  }
};
</script>
